module.exports = __webpack_public_path__ + "img/leave-requests.e0dd7876.svg";